/**
 * WhatsApp delivery status, quality/rate-limit tiers, retry + DLQ (S147).
 *
 * Outbound messages advance queued→sent→delivered→read (or fail). Retries back off and dead-letter after a max.
 * The WhatsApp Business quality rating gates messaging throughput — a RED-rated number is blocked until it
 * recovers. All numeric bounds are policy inputs; no country literal.
 */
import { err, ok } from '@vello/core';
export const DELIVERY_STATUSES = ['queued', 'sent', 'delivered', 'read', 'failed'];
const EDGES = {
    queued: ['sent', 'failed'],
    sent: ['delivered', 'read', 'failed'],
    delivered: ['read', 'failed'],
    read: [],
    failed: [],
};
export function canAdvance(from, to) {
    return EDGES[from].includes(to);
}
export function advanceStatus(from, to) {
    if (!canAdvance(from, to))
        return err({ code: 'ILLEGAL_STATUS', message: `${from} -> ${to}` });
    return ok(to);
}
// ---- Quality / rate limiting -----------------------------------------------------------------------
export const QUALITY_RATINGS = ['GREEN', 'YELLOW', 'RED'];
/** Messaging-limit tier by quality: RED is blocked (0), YELLOW throttled, GREEN full. Limits are policy inputs. */
export function throughputLimit(rating, tierLimits) {
    if (rating === 'RED')
        return 0;
    return rating === 'YELLOW' ? tierLimits.yellow : tierLimits.green;
}
export function isBlockedByQuality(rating) {
    return rating === 'RED';
}
/** Record a delivery failure: retry until maxAttempts, then dead-letter (a broken send never loops forever). */
export function recordFailure(state) {
    const attempts = state.attempts + 1;
    if (attempts >= state.maxAttempts) {
        return { state: { ...state, attempts, deadLettered: true }, action: 'dead_letter' };
    }
    return { state: { ...state, attempts }, action: 'retry' };
}
/** Exponential backoff (ms) for attempt n, capped. */
export function backoffMs(attempt, baseMs, capMs) {
    return Math.min(capMs, baseMs * 2 ** Math.max(0, attempt - 1));
}
//# sourceMappingURL=delivery.js.map